import { CircularProgress, Typography } from "@material-ui/core";
import { memo, useEffect, useState, useRef } from "react";

import { FileRemoveAction } from "../../types";
import { Overlay } from "../Overlay";

import styles from "./CorruptedFile.module.scss";

type CorruptedFileProps = {
  readonly onFileRemove: FileRemoveAction;
};

const TIMEOUT_MS = 5000;
const INTERVAL_MS = 50;

export const CorruptedFile = memo<CorruptedFileProps>(({ onFileRemove }) => {
  const [progressBar, setProgressBar] = useState(100);
  const progressBarRef = useRef(progressBar);
  progressBarRef.current = progressBar;

  useEffect(() => {
    const timeout = setTimeout(() => {
      onFileRemove();
    }, TIMEOUT_MS);
    const interval = setInterval(() => {
      setProgressBar(
        Math.round(progressBarRef.current - (INTERVAL_MS * 100) / TIMEOUT_MS)
      );
    }, INTERVAL_MS);

    return () => {
      onFileRemove();
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [onFileRemove]);

  return (
    <Overlay>
      <CircularProgress variant="determinate" value={progressBar} />
      <Typography align="center" className={styles.description}>
        Uszkodzony plik
      </Typography>
    </Overlay>
  );
});
